import { useIsDisplayOptimized } from '../transitional/context/DisplayOptimizedContext';

/**
 * Hook to determine if focus styles should be disabled.
 * Returns true if disableFocusStyles is explicitly set or if a display optimized context.
 * @param disableFocusStyles - Optional boolean to explicitly enable/disable focus styles
 * @returns boolean indicating whether focus styles should be disabled
 */
export const useDisableFocusStyles = disableFocusStyles => {
  const isDisplayOptimized = useIsDisplayOptimized();
  return disableFocusStyles !== null && disableFocusStyles !== void 0 ? disableFocusStyles : isDisplayOptimized;
};